export default [
  {
    //  结语
    path: "/conclusion",
    name: "conclusion",
    component: () => import("@/views/conclusion/index.vue"),
    meta: {
      title: "结语",
      order: 21,
      episode: "episode8",
      prefetchAssets: {
        isLoad: false,
        assets: ["images/conclusion/bg.jpg"],
      },
    },
  },
];
